export default __webpack_public_path__ + "static/media/right_shape.48b94e20.png";